/**
 *
 * @export
 * @class Account
 */
export class Account {
  //Fields
  firstName: string;
  lastName: string;
  extension: number;
  statusVpn: boolean;
  statusSip: boolean;
  clientStatus: string;
  linphoneStatus: string;
  accountStatus: number;
  accountId: string;
  description: string;
  realAddress: string;
  bytesSent: number;
  connectedSince:string;
  ipv4Address:string;
  netMask:string;
  gateway:string;
  email:string;
  location:string;
  activeKeys:number;
  altIpv4Address?:string;
  altNetMask?:string;
  altGateway?:string;
  //ecdsaA?: string;
  //ecdsaB?: string;

  constructor(
    firstName: string,
    lastName: string,
    extension: number,
    statusVpn: boolean,
    statusSip: boolean,
    clientStatus: string,
    linphoneStatus: string,
    accountStatus: number,
    accountId: string,
    description: string,
    realAddress: string,
    bytesSent: number,
    connectedSince:string,
    ipv4Address:string,
    netMask:string,
    gateway:string,
    email:string,
    location:string,
    activeKeys:number,
    altIpv4Address?:string,
    altNetMask?:string,
    altGateway?:string,
    //ecdsaA?: string,
    //ecdsaB?: string,
  ) {
    this.firstName = firstName;
    this.lastName = lastName;
    this.extension = extension;
    this.statusVpn = statusVpn;
    this.statusSip = statusSip;
    this.clientStatus = clientStatus;
    this.linphoneStatus = linphoneStatus;
    this.accountStatus = accountStatus;
    this.accountId = accountId;
    this.description = description;
    this.realAddress=realAddress;
    this.bytesSent=bytesSent;
    this.connectedSince=connectedSince;
    this.ipv4Address=ipv4Address;
    this.netMask=netMask;
    this.gateway=gateway;
    this.email=email;
    this.location=location;
    this.activeKeys=activeKeys;
    this.altIpv4Address=altIpv4Address || "";
    this.altNetMask=altNetMask || "";
    this.altGateway=altGateway || "";

    //this.ecdsaA = ecdsaA || "";
    //this.ecdsaB = ecdsaB || "";
  }
}
